var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgType = function SvgType(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_421)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.71082,
    y: 3.32892,
    width: 2.91906,
    height: 2.91906,
    stroke: "black",
    strokeWidth: 0.875717,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.71082,
    y: 9.64868,
    width: 2.91906,
    height: 2.91906,
    stroke: "black",
    strokeWidth: 0.875717,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.27112,
    y: 3.32892,
    width: 2.91906,
    height: 2.91906,
    stroke: "black",
    strokeWidth: 0.875717,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.27112,
    y: 9.64868,
    width: 2.91906,
    height: 2.91906,
    stroke: "black",
    strokeWidth: 0.875717,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "white",
    transform: "translate(0 0.498901)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgType);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "728d593f454969d518c6ab824f557cd2.svg";